export const MiniProgressSpinner = () => {
    return <div className="block animate-spin font-bold p-0 m-0 h-6 w-6 text-center leading-5 float-left mr-2 text-xl">&#9696;</div>;
}